import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
// import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
// import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Deposit = () => {
  const [deposit, setDeposit] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`deposit?page=${page}`);

      setDeposit(data.data);
      setLastPage(data.meta.last_page);
      setTotal(data.meta.total);
    })();
  }, [page]);
  // const del = async (id) =>{
  //     if(window.confirm("Are you sure you want to delete this record?")){
  //         await axios.delete(`deposit/${id}`);
  //         setDeposit(deposit.filter((deposit) => deposit.id !== id));
  //     }
  // }

  const formatTransactionDate = (dateString) => {
    if (!dateString) return "";

    const str = dateString.toString();

    const year = str.substring(0, 4);
    const month = str.substring(4, 6);
    const day = str.substring(6, 8);
    const hour = str.substring(8, 10);
    const minute = str.substring(10, 12);
    const second = str.substring(12, 14);

    const date = new Date(year, month - 1, day, hour, minute, second);

    return date.toLocaleString("en-KE", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <Wrapper pageTitle={"Deposits"}>
      <div className="w-full overflow-x-auto bg-white text-right leading-10 text-purple-700 pr-2">
        {" "}
        Page{" "}
        <span className="rounded-full bg-purple-700 text-white p-2">
          {page}
        </span>
        /{lastPage} Total Records: {total}{" "}
      </div>
      <Paginator lastPage={lastPage} pageChanged={setPage} />
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">TimeIn </th>
                <th className="px-4 py-3">Phone / Account </th>
                <th className="px-4 py-3">Amount </th>
                <th className="px-4 py-3">Name </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {deposit.map((deposit) => {
                return (
                  <tr
                    key={deposit.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{deposit.MpesaReceiptNumber}</td>
                    <td className="px-4 py-3 text-sm">
                      {formatTransactionDate(deposit.TransactionDate)}
                    </td>
                    <td className="px-4 py-3 text-sm">{deposit.PhoneNumber}</td>
                    <td className="px-4 py-3 text-sm">{deposit.Amount}</td>
                    <td className="px-4 py-3 text-sm">{deposit.misc4}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Deposit;
